/**
 * Account dropdown for the JWC custom header.
 *
 * @extends {HTMLElement}
 */
class CustomHeaderAccountMenu extends HTMLElement {
  /** @type {HTMLButtonElement | null} */
  #trigger = null;

  /** @type {HTMLElement | null} */
  #panel = null;

  /** @type {(event: MouseEvent) => void} */
  #onDocumentClick = (event) => {
    if (!this.contains(/** @type {Node} */ (event.target))) {
      this.#close();
    }
  };

  /** @type {(event: KeyboardEvent) => void} */
  #onDocumentKeydown = (event) => {
    if (event.key === 'Escape') {
      this.#close();
    }
  };

  connectedCallback() {
    this.#trigger = this.querySelector('.custom-header-profile');
    this.#panel = this.querySelector('.custom-header-account-menu__panel');

    if (!this.#trigger || !this.#panel) return;

    this.#trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.#toggle();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#onDocumentClick);
    document.removeEventListener('keydown', this.#onDocumentKeydown);
  }

  #toggle() {
    if (this.#panel?.classList.contains('is-open')) {
      this.#close();
      return;
    }

    this.#open();
  }

  #open() {
    if (!this.#trigger || !this.#panel) return;

    this.#panel.classList.add('is-open');
    this.#panel.removeAttribute('hidden');
    this.#trigger.setAttribute('aria-expanded', 'true');

    document.addEventListener('click', this.#onDocumentClick);
    document.addEventListener('keydown', this.#onDocumentKeydown);
  }

  #close() {
    if (!this.#trigger || !this.#panel) return;

    this.#panel.classList.remove('is-open');
    this.#panel.setAttribute('hidden', '');
    this.#trigger.setAttribute('aria-expanded', 'false');

    document.removeEventListener('click', this.#onDocumentClick);
    document.removeEventListener('keydown', this.#onDocumentKeydown);
  }
}

if (!customElements.get('custom-header-account-menu')) {
  customElements.define('custom-header-account-menu', CustomHeaderAccountMenu);
}
